export default {
  path: '/',
  name: 'recharge',
  component: () => import('@/layouts/BaseLayout'),
  children: [
    {
      path: 'recharge',
      name: 'recharge', 
      meta: { title: '充值', permission: 'recharge' },
      component: () => import('@/views/recharge/index'),
    },
  ],
}